import styled from "styled-components/macro";

export default styled.div`
    min-height: 300px;
    background: rgb(2,0,36);
    background: url('/dictionary.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
`;